<template>
    <k-page background="bg-white">
        <template v-slot:header>
            <profile-header/>
        </template>
        <k-container class="py-10">
            <div class="max-w-3xl mx-auto">
                <h1 class="text-3xl font-bold mb-8">{{ $t("acceptTerms") }}</h1>
                <acceptTerms-form :validation="validation" @submit="onSubmit"/>
            </div>
        </k-container>
        <template v-slot:footer>
            <k-footer/>
        </template>
    </k-page>
</template>

<script>
    import AcceptTermsForm from '@product-common/components/investor/AcceptTermsForm';
    import ProfileHeader from '@investor/components/profile/ProfileHeader';

    export default {
        components: {
            ProfileHeader,
            AcceptTermsForm,
        },
        data() {
            return {
                validation: {
                    fieldErrors: {}
                }
            }
        },
        methods: {
            async onSubmit(form) {
                this.validation = {
                    fieldErrors: {}
                };
                try {
                    await this.$post('registration/accept-terms', form);
                    await this.$fetchInvestorProfile();
                    await this.$routeInvestor();
                } catch (error) {
                    console.error(error)
                    if (error.response && error.response.status === 400) {
                        this.validation = error.response.data;
                    }
                }
            },
        }
    }
</script>


